import DiagnosticLogCreate from './create';
import DiagnosticLogList from './list';
import DiagnosticLogShow from './show';
import DiagnosticLogEdit from './edit';

export default {
    create: DiagnosticLogCreate,
    list: DiagnosticLogList,
    show: DiagnosticLogShow,
    edit: DiagnosticLogEdit
};